export default __webpack_public_path__ + "static/media/logo_quilmes.9f1ca890.svg";